import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DashboardUserService } from "src/app/service/dashboard.user.service";

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent {
    user: string | null;
    changePasswordScreen: boolean = false;
    constructor(
        private router: Router,
        private toastr: ToastrService,
        private dashboardUserService: DashboardUserService,
    ) { }

    ngOnInit() {
        this.dashboardUserService.user$.subscribe(user => {
            console.log("User from service: ", user);
            this.user = user;
        });

        this.dashboardUserService.changePasswordScreen$.subscribe(value => {
            this.changePasswordScreen = value;
        });
    }

    onClose() {
        this.router.navigate([""]);
    }

    handleLoginSuccess(event: string) {
        this.user = event;
        this.dashboardUserService.setUser(event);
        this.dashboardUserService.setChangePasswordScreen(false);
    }

    handleLoginFailure(event: string) {
        this.user = null;
        this.toastr.error(event);
        this.dashboardUserService.setChangePasswordScreen(false);
    }
}
